import { render, staticRenderFns } from "./exhorList.vue?vue&type=template&id=be828ab4&scoped=true&"
import script from "./exhorList.vue?vue&type=script&lang=js&"
export * from "./exhorList.vue?vue&type=script&lang=js&"
import style0 from "./exhorList.vue?vue&type=style&index=0&id=be828ab4&scoped=true&lang=css&"
import style1 from "./exhorList.vue?vue&type=style&index=1&id=be828ab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be828ab4",
  null
  
)

export default component.exports